import AppHome from '../components/home';
import AppAdmin from '../components/admin/AppAdmin';

const HomeRoutes = [
  {path: '/', component: AppHome, exact: true, public: true},
  {path: '/admin', component: AppAdmin, exact: false, public: true},
];

export const routes = HomeRoutes;
